import React, { FunctionComponent } from 'react';

import { Product, ProductSpecialFeatures } from 'src/types';
import { getIconPath } from 'src/utils';
import * as copy from '../../constants/copy';
import * as styles from '../../styles/productOverview.styles';

const ICON_GIFT = getIconPath('icons-24-gift.svg');
const ICON_LEAF = getIconPath('icons-24-leaf.svg');
const ICON_MODE_EDIT = getIconPath('icons-24-mode-edit.svg');
const ICON_LOCATION_PIN = getIconPath('icons-24-location-pin.svg');
const ICON_STAR = getIconPath('icons-24-star-circle-filled.svg');

type ProductOverviewProps = ProductSpecialFeatures &
  Pick<Product, 'allowsGiftWrap' | 'freeGiftWrap'>;

interface OverviewItemProps {
  text: string;
  icon: string;
}

const OverviewItem: FunctionComponent<OverviewItemProps> = ({ text, icon }: OverviewItemProps) => (
  <li css={styles.listItem}>
    <img css={styles.image} src={icon} alt="" width="24" height="24" />
    {text}
  </li>
);

export const ProductOverview: FunctionComponent<ProductOverviewProps> = ({
  allowsGiftWrap,
  freeGiftWrap,
  madeInBritain,
  personalisable,
  ecoFriendly,
  exclusive,
}: ProductOverviewProps) => (
  <ul css={styles.list}>
    {madeInBritain && <OverviewItem icon={ICON_LOCATION_PIN} text={copy.MADE_IN_BRITAIN} />}
    {ecoFriendly && <OverviewItem icon={ICON_LEAF} text={copy.ECO_FRIENDLY} />}
    {exclusive && <OverviewItem icon={ICON_STAR} text={copy.EXCLUSIVE} />}
    {personalisable && <OverviewItem icon={ICON_MODE_EDIT} text={copy.PERSONALISATION_AVAILABLE} />}
    {allowsGiftWrap && (
      <OverviewItem
        icon={ICON_GIFT}
        text={freeGiftWrap ? copy.FREE_GIFT_WRAPPING_AVAILABLE : copy.GIFT_WRAPPING_AVAILABLE}
      />
    )}
  </ul>
);
